import React, { useState } from 'react';

import { PlanogramVersion } from 'types';
import AnimationSettingsCard from 'components/AnimationSettingsCard/AnimationSettingsCard';
import { AnimationSettingsType } from 'types/animation';
import { planogramsModel } from 'models';

interface AnimationSettingsProps {
  planogramVersion: PlanogramVersion;
  planogramId: number;
  handleServerError: (err: any) => void;
  setSuccessActionMessages: (messages: string[]) => void;
}

export function AnimationSettings({
  planogramVersion,
  planogramId,
  handleServerError,
  setSuccessActionMessages,
}: AnimationSettingsProps) {
  const [expanded, setExpanded] = useState(Object.keys(planogramVersion.animationSettings).length > 0);
  const [animationSettings, setAnimationSettings] = useState<AnimationSettingsType | {}>(
    planogramVersion.animationSettings,
  );

  const onSaveAnimationSettings = async (settings: AnimationSettingsType | undefined) =>
    planogramsModel
      .editVersion(planogramId, planogramVersion.id, { animationSettings: settings ?? {} })
      .then(data => {
        setSuccessActionMessages(data.success);
        setAnimationSettings(data.planogramVersion.animationSettings ?? {});
      })
      .catch(handleServerError);

  const hasAnimationSettings = Object.keys(animationSettings).length > 0;

  return (
    <AnimationSettingsCard
      onSaveAnimationSettings={onSaveAnimationSettings}
      animationSettings={hasAnimationSettings ? (animationSettings as AnimationSettingsType) : undefined}
      descriptionKey="pages.planograms.ManagePlanogramSettings.animationSettings.description"
      expanded={expanded}
      onToggleExpanded={() => setExpanded(prevState => !prevState)}
    />
  );
}
